import { render, staticRenderFns } from "./notification-header.vue?vue&type=template&id=72b5c7ee&"
import script from "./notification-header.vue?vue&type=script&lang=js&"
export * from "./notification-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports